import { useSearchParams } from 'react-router-dom';

const INCLUDE_CLOSED = 'includeClosed';

/** Query param carrying the "show closed accounts" toggle across the reporting tabs. */
export const REPORTING_INCLUDE_CLOSED_SEARCH_PARAMS = [INCLUDE_CLOSED] as const;

export const readIncludeClosed = (params: URLSearchParams): boolean => params.get(INCLUDE_CLOSED) === 'true';

/**
 * Writes the toggle into `params` in place. Off is the default and is represented by omitting the
 * param, so existing links keep their meaning and the URL stays clean. Exposed so a caller changing
 * several reporting filters at once can compose them into a single URL update.
 */
export const applyIncludeClosed = (params: URLSearchParams, includeClosed: boolean): URLSearchParams => {
    if (includeClosed) {
        params.set(INCLUDE_CLOSED, 'true');
    } else {
        params.delete(INCLUDE_CLOSED);
    }
    return params;
};

/**
 * Reads the "show closed accounts" toggle from the `includeClosed` query param. Mirrors the
 * reporting API's `includeClosed` parameter: when on, the whole-household total also covers closed
 * accounts and the selector offers them. ReportingAccountSelector writes it.
 */
export const useReportingIncludeClosed = (): { includeClosed: boolean } => {
    const [params] = useSearchParams();
    return { includeClosed: readIncludeClosed(params) };
};
